<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'report',
    subject: 'Incident',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-alarm-warning-line',
  color: 'error',
  title: 'Insiden Keselamatan Pasien (IKP)',
  description: 'Melaporkan dan menginvestigasi insiden, dari Near Miss sampai Sentinel.',
  purpose: 'Panduan melaporkan insiden keselamatan pasien dan memahami alur investigasinya.',
  concept: [
    {
      icon: 'ri-error-warning-line',
      title: '5 Jenis Insiden',
      text: 'Near Miss (hampir terjadi, tidak sampai kena pasien), KPC (kondisi potensial cedera), KNC (nyaris cedera), KTD (kejadian tidak diharapkan), dan Sentinel (paling serius). Pilih jenis yang paling sesuai kejadian sebenarnya.',
    },
    {
      icon: 'ri-flow-chart',
      title: 'Alur: Dilaporkan → Investigasi → Dipantau → Ditutup',
      text: 'Setelah dilaporkan, insiden bisa masuk tahap investigasi (mencari akar masalah) yang sering menghasilkan Task tindak lanjut atau CAPA.',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → IKP, klik "Lapor Insiden"', detail: 'Isi Jenis Insiden, Unit, Judul singkat, kronologi kejadian, dan tanggal/waktu kejadian.' },
    { title: 'Klik "Simpan"', detail: 'Nomor insiden dibuat otomatis (format IKP/0001/2026).' },
    { title: '(Jika perlu) Klik "Investigasi"', detail: 'Isi akar masalah dan metode analisis yang dipakai (mis. 5 Whys, Fishbone).' },
    { title: 'Buat CAPA kalau diperlukan tindakan korektif', detail: 'Bisa langsung dari halaman detail insiden.' },
    { title: 'Klik "Tutup Insiden" setelah semua CAPA terkait selesai', detail: 'Sistem akan menolak penutupan kalau masih ada CAPA yang belum selesai.' },
  ],
  tips: [
    'Laporkan insiden sesegera mungkin setelah kejadian, selagi kronologinya masih jelas diingat.',
    'Gunakan AI Assistant (kalau edisi Anda mendukung) untuk mendapat saran awal akar masalah — tetap perlu diverifikasi Tim Mutu.',
  ],
  faq: [
    { q: 'Kenapa saya tidak bisa menutup insiden saya?', a: 'Insiden tidak bisa ditutup selama masih ada CAPA terkait yang berstatus belum selesai — selesaikan dulu semua CAPA-nya.' },
    { q: 'Siapa saja yang bisa melihat laporan insiden saya?', a: 'Tim Mutu dan role dengan akses IKP di unit terkait — bukan seluruh staf, sesuai kebijakan kerahasiaan pelaporan insiden.' },
  ],
  related: [
    { title: 'CAPA', sub: 'Tindak lanjut korektif dari insiden', icon: 'ri-tools-line', color: 'primary', to: { name: 'help-mutu-capa' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
